module.exports = __webpack_public_path__ + "img/left-1.4e8aaf4a.png";